import { Table } from "react-bootstrap";
import Loader from "react-loader-spinner";
import { Download, Trash, Upload } from "react-bootstrap-icons";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ModalSelectStaff from "../Components/ModalSelectStaff";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { getAttachmentList, getCustomerBaseInfoes, getCustomerEvents, getCustomerTicketList, getCutomerByID, getEventTypeList, getPreCustomerProductList, getRemainedAccount } from "../store/api/CustomerApi";
import { getAllProvinces } from "../store/api/LocationAPI";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import CustomerInfo from "../Components/Customer/CustomerInfo.js";
import CustomerEvents from "../Components/Customer/CustomerEvents";
import { attachFile, deleteAttachment, downloadFile, useIsMobileApp } from "../../store/api/CommonFunctions";
import CustomerServiceList from "../Components/Customer/CustomerServiceList";
import { getCustomerServiceList } from "../store/api/ServiceAPI";
import CustomerTickets from "../Components/Customer/CustomerTickets";
import PreCustomerProduct from "../Components/Customer/PreCustomerProduct";
import CustomerCallHistory from "../Components/Customer/CustomerCallHistory.js";
import CustomerInvoices from "../Components/Customer/CustomerInvoices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIdCard, faIdCardAlt } from "@fortawesome/free-solid-svg-icons";
import CustomerSMSHistory from "../Components/Customer/CustomerSMSHistory.js";

const AddEditCustomer = () => {
    const { id } = useParams();
    const attachInput = useRef();
    const dispatch = useDispatch();
    const isMobile = useIsMobileApp();
    const [remainedAcc, setRemainedAcc] = useState(0);
    const settingNames = ['Customer_SendWelcomeSMS', 'NationalCodeIsRequired', 'ProductGrouppingType', 'Services_ProductSerial_IsEnglish', 'Customer_ExtAttr1', 'Customer_ExtAttr2', 'Customer_ExtAttr3', 'Customer_ExtAttr4', 'Customer_ExtAttr5'];
    const attachList = useSelector(state => state.customerDataReducer.attachmentList);
    const onSelectTab = (index) => {
        if (index === 1) {
            let searchData = {};
            searchData.Skip = 0;
            searchData.CustomerID = id;
            searchData.Take = 10;
            searchData.IsPreCustomer = false;
            searchData.IsStaff = false;
            dispatch(getCustomerEvents(searchData));

        }
        else if (index === 2) {
            let searchData = {};
            searchData.Skip = 0;
            searchData.CustommerId = id;
            searchData.Take = 10;
            dispatch(getCustomerServiceList(searchData));
        }
        else if (index === 3) {
            dispatch(getCustomerTicketList({ Take: 10, Skip: 0, CustomerID: id }));
        }
        else if (index === 5) {
            dispatch(getPreCustomerProductList(id, false));
        }
        else if (index === 6) {
            dispatch(getAttachmentList(id, "CustomerAttachment"));
        }
    }
    const attach = () => {
        dispatch(attachFile(attachInput.current, id, "CustomerAttachment", () => { dispatch(getAttachmentList(id, "CustomerAttachment")) }));
    }
    const deleteAttach = (attachID) => {
        dispatch(deleteAttachment(attachID, "CustomerAttachment", () => { dispatch(getAttachmentList(id, "CustomerAttachment")) }));
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مشتریان";
        dispatch(getSystemSettings(settingNames));
        dispatch(getAllProvinces());
        dispatch(getCustomerBaseInfoes());
        dispatch(getEventTypeList());
        if (Number(id) > 0) {
            // dispatch(getCutomerByID(id));
            getRemainedAccount(id, 3, setRemainedAcc);
        }
    }, [id])

    return (
        <div className="container-fluid mt-1">
            <br />
            <div className="card">
                <div className="card-header headerStyle">
                    <FontAwesomeIcon icon={faIdCard} size="lg" />&nbsp;
                    اطلاعات مشتری</div>
                <div className="card-body bodyStyle" style={{ textAlign: "right" }}>
                    <ModalSelectStaff />
                    <Tabs onSelect={index => onSelectTab(index)}>
                        <TabList>
                            <Tab>
                                اطلاعات مشتری
                            </Tab>
                            <Tab disabled={!(Number(id) > 0)}>
                                رویدادها
                            </Tab>
                            <Tab disabled={!(Number(id) > 0)}>
                                خدمات
                            </Tab>
                            {!isMobile &&
                                <>
                                    <Tab disabled={!(Number(id) > 0)}> تیکت های پشتیبانی </Tab>
                                    <Tab disabled={!(Number(id) > 0)}>فاکتورها</Tab>
                                    <Tab disabled={!(Number(id) > 0)}>محصولات درخواستی</Tab>
                                </>}

                            <Tab disabled={!(Number(id) > 0)}>پیوست ها</Tab>
                            {!isMobile && <>
                                <Tab disabled={!(Number(id) > 0)}> تاریخچه تماس ها  </Tab>
                                <Tab disabled={!(Number(id) > 0)}>تاریخچه پیامک ها</Tab>
                            </>
                            }
                        </TabList>
                        <TabPanel>
                            <label style={{ color: remainedAcc.Color, border: "solid black 1px", padding: "5px", borderRadius: "2px" }}>مانده حساب: {Math.abs(remainedAcc.RemainedAccount ?? 0).toLocaleString(navigator.language, { minimumFractionDigits: 0 }) + " " + (remainedAcc.Type ?? "")}</label>
                            <CustomerInfo id={id} />
                        </TabPanel>
                        <TabPanel >
                            <CustomerEvents customerID={id} />
                        </TabPanel>
                        <TabPanel>
                            <CustomerServiceList customerID={id} />
                        </TabPanel>
                        {!isMobile &&
                            <>
                                <TabPanel>
                                    <CustomerTickets customerID={id} />
                                </TabPanel>
                                <TabPanel>
                                    <CustomerInvoices customerID={id} />
                                </TabPanel>
                                <TabPanel>
                                    <PreCustomerProduct preCustomerID={id} customerID={id} isPreCustomer={false} />
                                </TabPanel>
                            </>}
                        <TabPanel>
                            <div className="form-group col-md-5">
                                <input ref={attachInput} className='form-control' style={{ display: "inline-block", maxWidth: "70%" }} type="file"></input>
                                <button type="button" className="btn btn-primary btn-block group-Btn" onClick={attach}><Upload size={18} /></button>
                            </div>
                            <Table className="mt-3">
                                <thead>
                                    <tr>
                                        <th style={{ display: "none" }}></th>
                                        <th style={{ width: !isMobile ? "25%" : "20%", paddingRight: "2px" }}>تاریخ پیوست</th>
                                        <th style={{ paddingRight: "5px", width: !isMobile ? "70%" : "55%" }}>نام فایل</th>
                                        <th style={{ paddingRight: "5px", width: !isMobile ? "5%" : "20%" }}> </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attachList === "PENDING" &&
                                        <tr>
                                            <td colSpan={4} style={{ textAlign: "center" }}>
                                                <Loader type="BallTriangle" color="#bb1370" height={30} width={30} />
                                            </td>
                                        </tr>}
                                    {attachList && Array.isArray(attachList) && attachList.map((item, i) => {
                                        return (
                                            <tr key={i} className="resultTableRow">
                                                <td style={{ display: "none" }}></td>
                                                <td>{item.PAttachDate}</td>
                                                <td>{item.AttachFileName}</td>
                                                <td>
                                                    <Download size={18} style={{ color: 'green' }}
                                                        onClick={() => {
                                                            downloadFile(item.ID, "CustomerAttachment");
                                                        }} />
                                                    &nbsp;
                                                    <Trash size={18} style={{ color: 'red' }}
                                                        onClick={() => {
                                                            deleteAttach(item.ID)
                                                        }}
                                                    />
                                                </td>
                                            </tr>)
                                    })
                                    }
                                </tbody>
                            </Table>
                        </TabPanel>
                        {!isMobile &&
                            <>
                                <TabPanel>
                                    <CustomerCallHistory customerID={id} callerType="customer" />
                                </TabPanel>
                                <TabPanel>
                                    <CustomerSMSHistory customerID={id} />
                                </TabPanel>
                            </>}

                    </Tabs>

                </div>
            </div>
        </div>
    )
}
export default AddEditCustomer;